import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#025bac',
        secondary: '#f7f7f7',
        accent: '#FF5945',
        error: '#FF5252',
        info: '#2196F3',
        success: '#038700',
        warning: '#FFC107',
      },
    },
  },
})
